export function readerFlag(value) {
  return (
    value === true ||
    value === 1 ||
    ["true", "1", "activo", "activa", "active"].includes(
      String(value ?? "")
        .trim()
        .toLowerCase()
    )
  );
}
const clean = (value) =>
  String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
export function filterReaderGroups(groups, search = "", status = "todos") {
  const query = clean(search).trim();
  return groups
    .filter((group) => {
      if (status === "activos" && !group.activeReaders) return false;
      if (status === "inactivos" && group.activeReaders > 0) return false;
      return (
        !query ||
        [
          group.name,
          group.hostname,
          ...group.readers.flatMap((reader) => [
            reader.id,
            reader.hostname,
            reader.ip,
            reader.commerce,
            reader.reader_type,
            ...reader.antennas.flatMap((antenna) => [antenna.id, antenna.name]),
          ]),
        ].some((value) => clean(value).includes(query))
      );
    })
    .sort(
      (a, b) =>
        Number(b.activeReaders > 0) - Number(a.activeReaders > 0) ||
        String(a.name || "").localeCompare(String(b.name || ""), "es")
    );
}
export const antennaCount = (value) =>
  Array.isArray(value) ? value.length : Math.max(0, Number(value) || 0);
export function latestReaderUpdate(readers) {
  return readers.reduce((latest, reader) => {
    const value = reader.updatedAt;
    return value &&
      Number.isFinite(Date.parse(value)) &&
      (!latest || Date.parse(value) > Date.parse(latest))
      ? value
      : latest;
  }, null);
}
export function antennaActivity(value) {
  if (value === null || value === undefined || value === "") return "Sin verificar";
  const normalized = clean(value).trim();
  if (readerFlag(value)) return "Activa";
  if (
    value === false ||
    value === 0 ||
    ["false", "0", "inactiva", "inactivo", "inactive"].includes(normalized)
  )
    return "Inactiva";
  return "Sin verificar";
}
